export default function IconGift({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M22 15V19.6667C22 20.2855 21.7659 20.879 21.3491 21.3166C20.9324 21.7542 20.3671 22 19.7778 22H4.22222C3.63285 22 3.06762 21.7542 2.65087 21.3166C2.23413 20.879 2 20.2855 2 19.6667V15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M6 10L12 15L18 10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M12 14V2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}
